<template>
  <div class="">
    <label v-if="label != null" class="label-standard">{{ label }}</label>

    <div class="relative" style="margin-top:8px;">
      <input type="text"
        class="input-standard"
        ref="value"
        v-model="localValue"
        v-on:blur="inputBlurred($event.target.value)"
        v-on:keyup="onKeyup != null ? onKeyup($event.target.value) : false"
        v-on:focus="inputFocused"
        :placeholder="placeholder" />
    </div>

    <template v-if="!applicant.person.isPrimary">
      <div class="mt-2 flex items-center">
        <input type="checkbox" 
          class="mr-2"
          :id="'inputSpouseName' + applicant.id"
          :checked="localValue == getApplicantName($store.state[$store.state.view + 'Module'].client.applicants[0])"
          v-on:change="inputSpouseNameChanged($event.target.checked)" />

        <label :for="'inputSpouseName' + applicant.id">
          {{ getApplicantName($store.state[$store.state.view + 'Module'].client.applicants[0]) }}
        </label>
      </div>
    </template>
  </div>
</template>

<script>
  import ItemTemplate from './ItemTemplate.vue'

  export default {

    props : {

      applicant : {
        type : Object,
        required : false
      },

      objectType : {
        type    : String,
        required: false
      },

      objectId : {
        type : Number,
        required : false
      },

      label : {
        type    : String,
        required: false
      },

      subLabel : {
        type    : String,
        required: false
      },

      tooltip : {
        type    : String,
        required: false
      },

      propertyKey : {
        type    : String,
        required: false
      },
      // Object name is required if data array consist of two different data model e.g "broker" & "user" and we use object name to specfiy for which model we are updating the data in this component.
      objectName : {
        type    : String,
        required: false
      },

      value : {
        // type    : String,
        required: false
      },

      updateValue : {
        type : Function,
        required : false
      },

      index : {
        type    : Number,
        required: false,
      },

      // onKeyup is a function that will be called
      // for those cases where you need to do something
      // as the user types in
      onKeyup: {
        type : Function,
        required : false
      },

      placeholder: {
        type    : String,
        required: false
      },

      required : {
        type : Boolean,
        required : false
      },
    },

    watch: {
      value : {
        
        deep     : true,
        immediate: true,

        handler(newValue, oldValue) {
          this.localValue = newValue
        },

      },
    },

    data() {
      return {
        localValue : this.value,
      }
    },

    methods : {

      // for some components, we are updating something that is repeated via v-for.
      // For example, addresses. An applicant has multiple addresses, so we do
      // <v-for address in addresses>
      //   <InputText address>
      // But when we are doing the autosave, we actually need to know which address we are
      // updating. We can do this via index, which is passed as a prop.
      // For some, it's not repeated, so we don't need the index. So, instead of going
      // directly to updateValue, we are going via "localUpdateValue, so that we can check
      // if index exists, or not
      localUpdateValue(key, value) {
        if(this.index != null) {
          this.updateValue(this.objectType, this.index, key, value);
        }

        else if(this.objectName != null) {
          this.updateValue(this.objectName, key, value);
        } 

        else {
          this.updateValue(key, value);
        }
      },

      copyValue(fromApplicantId, applicantIndex) {
        this.localValue = this.$store.state[this.$store.state.view + 'Module'].client.applicants[applicantIndex].person[this.copyFrom]
      },

      inputFocused() {
        this.visibility = true
      },

      inputBlurred(value) {
        this.visibility = false

        this.updateValue({
          objectType: this.objectType,
          objectId  : this.objectId,
          index     : this.index,
          key       : this.propertyKey,
          value     : value
        })
      },

      getLabel (item) {
        if(item) {
          return item.name
        }

        return null
      },
      
      inputSpouseNameChanged(checked) {
        if(checked) {
          this.localValue = this.getApplicantName(this.$store.state[this.$store.state.view + 'Module'].client.applicants[0])
        } else {
          this.localValue = ""
          this.$refs.value.focus()
        }

        // update both this applicant and the primary
        this.updateValue({
          objectType: this.objectType,
          objectId  : this.objectId,
          index     : this.index,
          key       : this.propertyKey,
          value     : this.localValue
        })
      }
    }
  }
</script>